import React, { useState } from 'react'
import { Chip, Menu } from 'react-native-paper'
import { useRecoilState, useRecoilValue } from 'recoil'
import { Box } from '@/presentation/components'
import { useTheme, useThemeClient } from '@/presentation/hooks'
import { isLoadingState, unitsState } from '@/presentation/pages/Settings/components'
import { styles } from './styles'

export const UnitsSelector: React.FC = () => {
  const theme = useTheme()
  const { getThemeClient } = useThemeClient()
  const [isMenuOpen, setMenuOpen] = useState(false)
  const [{ units, currentUnit }, setUnits] = useRecoilState(unitsState)
  const isLoading = useRecoilValue(isLoadingState)

  const themeClient = getThemeClient()

  const handleSelectUnit = (currentUnit: number): void => {
    setUnits(currentState => ({ ...currentState, currentUnit }))
    setMenuOpen(false)
  }

  return (
    <Box>
      <Menu
        visible={isMenuOpen}
        onDismiss={() => setMenuOpen(false)}
        anchorPosition='bottom'
        anchor={
          <Chip
            disabled={isLoading}
            style={{ ...styles.headerChip, backgroundColor: themeClient.buttonSave }}
            selectedColor={theme.colors.white}
            ellipsizeMode='middle'
            onPress={() => setMenuOpen(true)}
          >
            {currentUnit.toString().padStart(4, '0')}
          </Chip>
        }
      >
        {units?.map((config) => (
          <Menu.Item
            key={config.codigoUnidade}
            disabled={config.codigoUnidade === currentUnit}
            onPress={() => handleSelectUnit(config.codigoUnidade)}
            title={`${config.codigoUnidade.toString().padStart(4, '0')} - ${config.nomeUnidade}`}
          />
        ))}
      </Menu>
    </Box>
  )
}
